export default defineAppConfig({
    ui: {
        primary: 'blue',
        gray: 'cool',
        notifications: {
            // Show toasts at the top right of the screen
            position: 'top-0 bottom-[unset]'
        }
    }
})